<template>
  <component :is="activeComponent" v-bind="$attrs" @close="emit('close')" />
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import Flyout from './Flyout.common.vue';
import { useEnvProps } from '~/stores/envProps';

const emit = defineEmits(['close']);
const { isNavSSR } = useEnvProps();

const LazyComponent = defineAsyncComponent({
  loader: () => Promise.resolve(Flyout),
  // Static import via Promise.resolve keeps Flyout in the main bundle
  // and avoids creating an extra async chunk.
  // To not affect INP metric.
  hydrate: () => {},
  // Intentionally do not call hydrate here.
  // !!! Nuxt/Vue will hydrate the component automatically when any
  // prop/attribute changes. In our case, hydration is triggered
  // when `isActive` changes through `v-bind="$attrs"`.
});

const activeComponent = isNavSSR ? LazyComponent : Flyout;
</script>
